import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dmmp-subcontent',
  templateUrl: './subcontent.component.html'
})
export class SubcontentComponent implements OnInit {
  @Input() module
  @Input() identifier
  @Input() subcontentInfo

  constructor() { }

  ngOnInit(): void {
  }

}
